// API item types from File Manager, and the quick-files shape consumers render.
export const ENTITY_FILE_ITEM_TYPE = {
  FILE: 'FILE',
  LINK: 'LINK',
  FOLDER: 'FOLDER',
};

export const QUICK_FILE_TYPE = {
  FILE: 'file',
  LINK: 'link',
};

export const DUPLICATE_STRATEGY = {
  REPLACE: 'REPLACE',
  KEEP_BOTH: 'KEEP_BOTH',
};
